<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-lg-8">

      <!-- Page header -->
      <div class="mb-4">
        <h2 class="fw-bold"><i class="bi bi-translate me-2"></i>Set Your Languages</h2>
        <p class="text-body-secondary">Choose your preferred languages for vocabulary learning. These will be used as defaults when adding new words.</p>
      </div>

      <!-- Language selection card -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-light">
          <h5 class="mb-0"><i class="bi bi-gear me-2"></i>Default Languages</h5>
        </div>

        <div class="card-body">
          <p class="text-body-secondary small mb-3">Choose the languages you want to translate between. Your "From" language is the one you're learning from, and "To" is the language you're translating into.</p>

          <div class="row g-4">
            <div class="col-md-6">
              <label for="language-select" class="form-label fw-semibold">
                <i class="bi bi-box-arrow-right me-1 text-primary"></i>From Language
              </label>
              <select id="language-select" class="form-select"
                [appTooltip]="'Click to change your default language'"
                (change)="onFromChange($event)">
                <option value="">-- Select Language --</option>
                @for (l of languages(); track l.uuid) {
                  <option
                    [value]="l.uuid"
                    [selected]="l.uuid === model().language?.uuid"
                    [disabled]="l.uuid === model().languageTo?.uuid">
                    {{ flags[l.name] }} {{ l.name }}
                  </option>
                }
              </select>
            </div>

            <div class="col-md-6">
              <label for="languageTo-select" class="form-label fw-semibold">
                <i class="bi bi-box-arrow-in-right me-1 text-success"></i>To Language
              </label>
              <select id="languageTo-select" class="form-select"
                [appTooltip]="'Click to change your default language'"
                (change)="onToChange($event)">
                <option value="">-- Select Language --</option>
                @for (l of languages(); track l.uuid) {
                  <option
                    [value]="l.uuid"
                    [selected]="l.uuid === model().languageTo?.uuid"
                    [disabled]="l.uuid === model().language?.uuid">
                    {{ flags[l.name] }} {{ l.name }}
                  </option>
                }
              </select>
            </div>
          </div>

          <p class="text-muted small mt-3 mb-0">
            <i class="bi bi-info-circle me-1"></i>Select your languages and click <strong>Save</strong> to update your defaults.
          </p>

          <!-- Current selection preview -->
          @if (model().language && model().languageTo && getLanguageName(model().language) && getLanguageName(model().languageTo)) {
            <div class="alert alert-light border mt-4 mb-0 text-center">
              <span class="fs-5">
                {{ flags[getLanguageName(model().language)] }} {{ getLanguageName(model().language) }}
              </span>
              <i class="bi bi-arrow-right mx-3 text-body-secondary"></i>
              <span class="fs-5">
                {{ flags[getLanguageName(model().languageTo)] }} {{ getLanguageName(model().languageTo) }}
              </span>
            </div>
          }

          <!-- Status messages -->
          <div class="mt-3">
            @if (saving()) {
              <div class="text-primary d-flex align-items-center">
                <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                <span>Saving changes...</span>
              </div>
            }

            @if (saved()) {
              <div class="alert alert-success py-2 mt-2 mb-0" role="alert"
                [style.opacity]="savedFading() ? '0' : '1'"
                style="transition: opacity 0.7s ease">
                <i class="bi bi-check-circle-fill me-2"></i>Preferences updated!
              </div>
            }

            @if (error()) {
              <div class="alert alert-danger py-2 mt-2 mb-0" role="alert">
                {{ error() }}
              </div>
            }
          </div>
        </div>

        <!-- Buttons -->
        @if (dirty()) {
        <div class="card-footer bg-white d-flex gap-2">
          <button class="btn btn-primary" (click)="save()" [disabled]="saving()">
            <i class="bi bi-check-lg me-1"></i>Save
          </button>
          <button class="btn btn-outline-secondary" (click)="cancel()" [disabled]="saving()">
            Cancel
          </button>
        </div>
        }
      </div>

      <!-- Available languages info -->
      <div class="card shadow-sm">
        <div class="card-header bg-light">
          <h5 class="mb-0"><i class="bi bi-globe me-2"></i>Available Languages</h5>
        </div>
        <div class="card-body">
          <p class="text-body-secondary small mb-3">The following languages are currently supported in Vocabulary.</p>
          <div class="d-flex flex-wrap gap-2">
            @for (l of languages(); track l.uuid) {
              <span class="badge bg-light text-dark border fs-6 px-3 py-2">
                {{ flags[l.name] }} {{ l.name }}
              </span>
            }
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
